import { render, staticRenderFns } from "./JsmTable.vue?vue&type=template&id=54a9819e&"
import script from "./JsmTable.vue?vue&type=script&lang=js&"
export * from "./JsmTable.vue?vue&type=script&lang=js&"
import style0 from "./JsmTable.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports